const MissingParams = () => {
  return <div>Missing Parameters, please check your url.</div>;
};

export default MissingParams;
